<template>
    <contentCard :loading="loading" :classCard="`py-1 px-1`">
        <template slot="cardContent">
                <div class="d-flex mb-0" >
                    <!-- sidebar -->
                    <SideBarProgress
                    :key="updateNavCat"
                    
                    :course="this.form"
                    @selectLessonAction="(v) =>{ selectLesson(v.lesson, v.indexSection, v.indexLession)}"
                    :valueInput="menu"
                    @valueChange="
                        (v) => {
                            menu = v;
                        }
                    "
                    ></SideBarProgress>
                
                    <!-- Body -->
                    <div class="courses-progress-h-full courses-progress-content-body">
                        <div>
                            <v-row justify="center"  class="courses-progress-main-title-row">
                            <v-col class="text-left col-md-12">
                                <div class="font-weight-bold body-1 courses-progress-main-container">
                                    <v-icon @click="menu=!menu" class="d-inline d-lg-none">
                                        mdi-menu
                                    </v-icon>
                                    {{ this.form.title }}
                                </div>
                            </v-col>
                            
                        </v-row>
                        <div v-if="!loadingLesson">
                            <v-row v-if="courseState == 'INIT'">
                                <v-col class="text-center" >
                                    <p>Selecciona una lección</p>
                                </v-col>
                            </v-row>
                            <v-row v-if="courseState == 'NO_CONTENT'">
                                <v-col class="text-center">
                                    <p>La lección no tiene contenido</p>
                                    <secondary-button v-if="deadEnd" :props="returnBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                                </v-col>
                            </v-row>
                            <v-row v-if="courseState == 'ERROR'">
                                <v-col class="text-center">
                                    <p>Hubo un problema al obtener la lección</p>
                                </v-col>
                            </v-row>
                        </div>
                        <v-col align-self="center" cols="12" class="text-center mt-5" v-if="loadingLesson">
                            <v-progress-circular
                                size="100"
                                indeterminate
                                color="secondary"
                            ></v-progress-circular>
                        </v-col>
                        <v-row v-if="selectedLesson != null && courseState == 'SELECT'" key="richKey" justify="center">
                            
                            <v-col v-if="!loadingLesson">
                                <RichTextForm
                                    :readMode="true"
                                    :valueInput="selectedLesson.content"
                                    :images_data="[]"
                                    @valueChange="
                                        (v) => {
                                            
                                        }
                                    "
                                    @imagesDataChanged="
                                        (v) => {
                                        
                                        }
                                    "
                                ></RichTextForm>
                                
                            </v-col>
                        </v-row>
                        </div>
                        <v-row justify="center" align="end" v-if="selectedLesson != null && courseState == 'SELECT'">
                            <v-col cols="12"  class="">
                                <v-row justify="end" class="px-3 py-3">
                                    <primary-button :props="saveBtnData" class=""></primary-button>  
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>
                    
                </div>
            


           

           
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../../../helpers/Utils';
import RichTextForm from '../../../../components/RichTextForm.vue';
import SideBarProgress from './SideBarProgress.vue';
// import DepForm from "./Form.vue";
export default {
    components: {
        RichTextForm,
        SideBarProgress
    },
	data(){
		return {
            menu:true,
            id: this.$route.params.id,
            step: '2',
            loadingLesson:false,
            secPass:0,
            richKey: 887,
            courseName: "nombre del curos",
            updateNavCat: 1,
            stepClasses: {st1: '', st2: '', st3: '', st4: ''},
            loading: false,
            serverErrors: {},
            showRichButtons:false,
            deadEnd:false,
            courseState: "INIT", //BLANK SELECTED NO_CONTENT
            selectedLesson:null,
            idLesson:-1,
            indexSectionSelected: -1,
            indexLessonSelected: -1,
            form: {
                title: "",
                brief_description:"",
                duration: "",
                summary: "",
                description: "",
                what_you_will_learn: "",
                sections:[
                    {
                        title: '',
                        lessons: [
                            {
                                title:'',
                                type: 'LECCIÓN',
                                has_content:false,
                                completed:false,
                                selected:false,
                            }
                        ]
                    }
                ],
                list_companies:[],
                draft:0,
                image_file: [],
                update_image_file: [],
                image_url: "",
                sections_to_delete: [],
                lessons_to_delete: [],

                images_data:[
                    // {id, url}
                ]
                // _method: "POST",
            },

            returnBtnData: {
                text: "Regresar a los cursos",
                icon: "",
                to: "ReadCourse",	
                block:false,
                click: () => {},
            },
          
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Courses",	
                block:false,
                click: () => {}
            },
           
            saveBtnData: {
                text: "Siguiente Lección",
                icon: "",	
                click: () => {this.completeLesson()},
                block:false,
                loading: false,
            },
            
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        this.index();
    },
	methods: {
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
        setTime: function(){

            setInterval(() => {
               this.secPass = this.secPass + 1;
            }, 1000)
        },
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
			return this.$refs.form.validate()
		},
       

        index(){
			//this.$store.state.overlay = true
			this.loading = true;
            this.$store.state.loading = true;
			this.$api.course.getProgress(this.id)
			.then((response) => {
                this.form.title = response.data.title;
                this.form.brief_description = response.data.brief_description;
                this.form.duration = response.data.duration;
                this.form.summary = response.data.summary;
                this.form.description = response.data.description;
                this.form.what_you_will_learn = response.data.what_you_will_learn;
                this.form.sections =response.data.sections;
                this.form.list_companies = response.data.companies.map((x) => {
                    return {text: x.name, value: x.id}
                });
                this.form.draft = response.data.draft == true ? 1 : 0;
                this.form.image_file = [];
                this.form.image_url = response.data?.image?.url??'';

                for (let i = 0; i < this.form.sections.length; i++) {
                    this.form.sections[i]
                    for (let index = 0; index < this.form.sections[i].lessons.length; index++) {
                        this.form.sections[i].lessons[index].type = this.form.sections[i].lessons[index].content_type;
                        // this.form.sections[i].lessons[index].completed = false;
                        this.form.sections[i].lessons[index].selected = false;

                    }
                    
                }

                //select a lesson by default
                this.selectDefaultLesson(this.form);


			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
				this.loading = false;
                this.$store.state.loading = false;
			})
		},

        

        completeLesson(){
			//this.$store.state.overlay = true
			this.saveBtnData.loading = true;

            const data = {
                employee_id: Number(this.$store.state.userData.id),
                time_spent: this.secPass,
                completed: true
            }
           
			this.$api.course.saveProgress(this.selectedLesson.id, data)
			.then((response) => {
                console.log(response)
                this.setSectionLessonCompleted(this.indexLessonSelected, this.indexSectionSelected)
                this.setNextLesson();


			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
                this.saveBtnData.loading = false;
			})
		},

        selectDefaultLesson(form){
            let nextLessonFound = false;
            let firstLesson = null;
            let indS = 0;
            let indL = 0;
            let lessonSelected = null;

            form.sections.forEach((section,indexS) => {
                section.lessons.forEach((lesson, indexL) => {
                lesson.selected = false;

                if (!firstLesson) {
                    firstLesson = lesson;
                }

                if (!nextLessonFound && !lesson.completed && lesson.has_content) {
                    lesson.selected = true; 
                    nextLessonFound = true; 
                    indS = indexS;
                    indL = indexL;
                    lessonSelected = lesson;
                }
                });
            });

            if (!nextLessonFound && firstLesson) {
                firstLesson.selected = true;
                lessonSelected = firstLesson;
            }
            this.selectLesson(lessonSelected, indS, indL);
        },

        setNextLesson(){
            console.log("next", this.form.sections[this.indexSectionSelected].lessons.length, this.indexLessonSelected)
            if(this.form.sections.length == this.indexSectionSelected +1 && this.form.sections[this.indexSectionSelected].lessons.length == this.indexLessonSelected + 1){
                //fin
                this.$router.push({ name: 'ReadCourse', params: { id: this.id }}).catch(()=>{});
                console.log("fin")
                return;
            }
            if(this.form.sections[this.indexSectionSelected].lessons.length == this.indexLessonSelected + 1){
                //next section
                this.indexSectionSelected = this.indexSectionSelected + 1;
                this.indexLessonSelected = 0;
               
            }else{
                this.indexLessonSelected = this.indexLessonSelected + 1;
            }
            console.log("primer if", this.form.sections[this.indexSectionSelected].lessons.length, this.indexLessonSelected)
           
            console.log("ok ?")
            let nextLesson = this.form.sections[this.indexSectionSelected].lessons[this.indexLessonSelected];
            console.log(nextLesson, this.indexLessonSelected, this.indexSectionSelected)
            this.selectLesson(nextLesson, this.indexSectionSelected, this.indexLessonSelected);
        },

        isLast(indexSection, indexLession){
            console.log(this.form.sections.length,indexSection, indexLession )
            if(this.form.sections.length == indexSection +1 && this.form.sections[indexSection].lessons.length == indexLession + 1){
                this.deadEnd = true;
                this.saveBtnData.text = "Finalizar curso";
            }else{
                 this.saveBtnData.text = "Siguiente Lección";
            }
        },

        selectLesson(lesson, indexSection, indexLession){
            this.loadingLesson = true;
            this.$api.course
                .getLesson(lesson.id)
                .then((resp) => {
                    // let bodyWithId = JSON.parse(JSON.stringify(lesson));
                    if(resp.data['content'] != null)
                    {
                        resp.data['content'] = {
                            'type': "doc",
                            'content': resp.data['content']
                        }
                        this.selectedLesson = resp.data;
                        this.courseState = 'SELECT'
                    }else{
                        this.courseState = 'NO_CONTENT'
                    }

                    
                    this.secPass = 0;
                    this.setTime();
                    this.isLast(indexSection, indexLession);
                    this.setLessonSelected(indexSection, indexLession)

                        
                    //     let bodyWithUrl = JSON.parse(JSON.stringify(resp.data));

                    //     for (let i = 0; i < bodyWithId.content.content.length; i++) {
                    //         const item = bodyWithId.content.content[i];
                    //         if(item.content != undefined && Array.isArray(item.content)){
                    //             for (let j = 0; j < item?.content?.length; j++) {
                    //                 const element = item?.content[j];
                    //                 if(element.type == 'image'){
                    //                     const id = element.attrs.src;
                    //                     const url = bodyWithUrl.content.content[i].content[j].attrs.src;
                    //                     this.values.images_data.push({id:id, url: url});
                    //                 }
                    //             }
                    //         }
                            
                    //     }
                    // }
                    

                    // console.log(this.values.images_data, "images_data");

                    
                    // // resp.data['content']['type'] = "doc";
                    // // resp.data['content']['content'] = resp.data['content'];
                    // this.values.sections[indexSection].lessons[indexLession] =resp.data;
                    // lesson = this.values.sections[indexSection].lessons[indexLession];
                    // this.showRich = true;
                    this.indexSectionSelected = indexSection;
                    this.indexLessonSelected = indexLession;
                   
                    // this.lessonBackup = resp.data['content'] == null ? lesson : bodyWithId; //JSON.parse(JSON.stringify(lesson));
                    // this.lessonBackup['type'] = this.lessonBackup.content_type;

                    console.log(this.selectedLesson)

                    // this.$emit('showRichChanged', {showRich: this.showRich, idLesson: lesson.id, indexSectionSelected: this.indexSectionSelected, indexLessonSelected: this.indexLessonSelected});
                })
                .catch((error) => {
                    console.log(error, "s");
                    this.courseState = 'ERROR';
                })
                .finally(() => {
                    this.loadingLesson = false;
                })
            ;

        },

        setSectionLessonCompleted(indexLession, indexSection){
            this.form.sections[indexSection].lessons[indexLession].completed = true;
            this.updateNavCat = this.updateNavCat + 1;
        },
        setLessonSelected(indexSection, indexLession){
            for (let i = 0; i < this.form.sections.length; i++) {
                for (let index = 0; index < this.form.sections[i].lessons.length; index++) {
                    this.form.sections[i].lessons[index].selected = false;

                }
                
            }
            this.form.sections[indexSection].lessons[indexLession].selected = true;
            this.updateNavCat = this.updateNavCat + 1;
        },

     



        
    },
}
</script>

<style lang="scss">
  

    .position-relative{
        position: relative;
    }

    .hr-base{
        position: absolute;
        height: 2px;
        width: 100%;
        bottom: 0;
        background-color: black;
    }

    .courses-progress{
        // &-h-full{
        //     max-height: calc(100vh - 148px);
        // }
        &-main-title-row{
            border-bottom: 1px solid black;
        }

        &-content-body{
           
            padding: 0.625rem 3.125rem 0.625rem 3.125rem;
            overflow-x: hidden;
            overflow-y: auto;

            display: flex;
            flex-direction: column;
            padding-bottom: 15px;

            @media (max-width: #{map-get($grid-breakpoints, 'md')}) {
                // width: calc(100% - 257px);
            }
        }

        &-side-title{
            font-weight: 600;
            font-size: 1rem;
            text-wrap-mode: wrap;
        }

        &-lesson-content{
            display: flex;
            align-items: baseline;
            justify-content: flex-end;
            p{
                padding-bottom: 0 !important;
            }
        }
        &-side-subtitle{
            font-weight: 600;
            font-size: 0.95rem;
            text-wrap-mode: wrap;
        }

        &-main-container{
            display: flex;
            justify-content: space-between;
        }

        &-title{
            font-weight: 800;
            font-size: 0.95rem;
        }


        &-item{
            display: flex;
        }

        &-list{
            padding-left: 30px !important;
            &-item li::marker {
                    font-size: 2rem;
                    color: #18585b;
                    // margin: 10px;
                }
        }

        &-selected-text{
            font-weight: 700;
            color: var(--v-primary-base);
        }
    }

</style>